import React, { useCallback, useEffect, useRef } from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import { Tab, Tabs, TabPanel } from 'react-tabs'
import { Switch } from '@mui/material'

import { setLoftSelected, setSelectedToolbarLoftFloorSubTab } from '../../store/ui/uiSlice'

import ContructionPlanPanel from './ContructionPlanPanel'
import FloorPanel from './FloorPanel'
import SwitchLabel from '../SwitchLabel/SwitchLabel'
import { ASSEMBLY_ID } from '../../constants/constants'

import * as Styled from '../styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

const LoftPanel: React.FC = () => {
  const dispatch = useAppDispatch()
  const configuratorRef = useRef(useConfiguratorContext())

  const { content } = useAppSelector((state) => state.init)
  const { loftSelected, selectedToolbarLoftFloorSubTab } = useAppSelector((state) => state.ui) || {}

  const { props } = useAppSelector((state) => state.configResult) || {}
  const { roofKind, loftLeft, loftRight } = props || {}

  const isLoftDisabled =
    (!loftLeft.options.find((option: any) => option.available) &&
      !loftRight.options.find((option: any) => option.available)) ||
    roofKind?.value === 'gable'

  useEffect(() => {
    let newLoftLeft = loftLeft.value
    let newLoftRight = loftRight.value

    if (!loftSelected) {
      newLoftLeft = 0
      newLoftRight = 0
    } else if (loftLeft.value === 0 && loftRight.value === 0) {
      newLoftLeft = loftLeft.options.find((x) => x.available && x.value > 0)?.value ?? 0
    }

    if (newLoftLeft !== loftLeft.value || newLoftRight !== loftRight.value) {
      configuratorRef.current.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
        loftLeft: newLoftLeft,
        loftRight: newLoftRight,
      })
    }
  }, [loftSelected, loftLeft, loftRight.value])

  const handleChange = useCallback(
    (event: any) => {
      dispatch(setLoftSelected(event.target.checked))
    },
    [dispatch]
  )

  return (
    <Styled.Panel>
      <SwitchLabel htmlFor="addLoft" label={content?.props.loft.addLoft.lable} info={content?.props.loft.addLoft.info}>
        <Switch
          id="addLoft"
          disabled={isLoftDisabled}
          checked={loftSelected && roofKind?.value !== 'gable'}
          onChange={handleChange}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      </SwitchLabel>

      <Styled.Panel>
        <Tabs
          selectedIndex={selectedToolbarLoftFloorSubTab}
          onSelect={(index) => {
            dispatch(setSelectedToolbarLoftFloorSubTab(index))
          }}
        >
          <Styled.SubTabsList>
            <Tab tabIndex="0">{content?.props.loft.constructionPlan.title}</Tab>
            <Tab tabIndex="1">{content.props.loft.floor.title}</Tab>
          </Styled.SubTabsList>
          <TabPanel>
            <ContructionPlanPanel disabled={!loftSelected || isLoftDisabled} />
          </TabPanel>
          <TabPanel>
            <FloorPanel disabled={!loftSelected || isLoftDisabled} />
          </TabPanel>
        </Tabs>
      </Styled.Panel>
    </Styled.Panel>
  )
}

export default LoftPanel
